import { pictureManager } from "@/services/utilities/picture-manager";

class ColorManager {
  buildStyle(trainingCourse, design = null) {
    let primaryColor = "#000";
    let secondaryColor = "#000";

    if (design) {
      primaryColor = design.principalColor ? design.principalColor : "#000";
      secondaryColor = design.secondaryColor ? design.secondaryColor : "#000";
    }

    if (trainingCourse && trainingCourse.training && trainingCourse.training.institution) {
      if (trainingCourse.training.institution.principalColor) {
        primaryColor = trainingCourse.training.institution.principalColor;
      }
      if (trainingCourse.training.institution.secondaryColor) {
        secondaryColor = trainingCourse.training.institution.secondaryColor;
      }
    }

    const css =
      "" +
      "body {" +
      "--primary-color: " +
      primaryColor +
      " !important;" +
      "--secondary-color: " +
      secondaryColor +
      " !important;" +
      "}";

    let style = document.createElement("style");
    style.type = "text/css";
    style.id = "platformStyle";
    style.innerHTML = css;
    document.getElementsByTagName("head")[0].appendChild(style);
  }

  setFavicon(design) {
    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon) {
      favicon.href = design && design.favicon ? pictureManager.setPicture(design.favicon, "favicon") : "/favicon.png";
    }
  }

  setPlatformStyle(trainingCourse = null, design) {
    let style = document.getElementById("platformStyle");
    if (style) {
      style.remove();
    }
    this.buildStyle(trainingCourse, design);
    this.setFavicon(design);
  }
}

export const colorManager = new ColorManager();
